<template>
  <b>
    {{ text?.substring(0, record.roll_no.length) }}
  </b>
  <b style="color: red">
    {{ text?.substring(record.roll_no.length) }}
  </b>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'Cell_bind_no',
  props: {
    column: {
      type: Object,
      required: true,
      default: () => {},
    },
    index: {
      type: Number,
      required: true,
    },
    text: {
      type: [String, Number],
      required: true,
    },
    record: {
      type: Object,
      required: true,
      default: () => {},
    },
    pageSize: {
      type: Number,
      required: true,
      default: () => 20,
    },
    current: {
      type: Number,
      required: true,
      default: () => 1,
    },
  },
});
</script>
<style lang="less">
.needCopyRow {
  td {
    position: relative;
  }
}
.large-font {
  font-weight: 500;
  font-size: 17px;
}
.large-number-font {
  font-weight: 500;
  font-size: 24px;
}
</style>
